import get from 'lodash.get';
import { config } from '@yola/ws-sdk';

const getWsLoginUrl = (rootState) => {
  const cfg = config.selectors.getConfig(rootState);

  return get(cfg, 'common.auth-gateway.url', null);
};

export default getWsLoginUrl;
